import { useSelector } from "react-redux"
import { combineReducers, createStore } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import { allVehicleReducer } from "store/all-vehicles/all-vehicles.reducer"
import { AllVehiclesState } from "store/all-vehicles/all-vehicles.types"
import authReducer from "./auth.redux"
import { demandReducer } from "./demand.redux"
import dispatchReducer from "./dispatch.redux"
import { orderReducer } from "./order.redux"
import reportsReducer from "./reports.redux"
import schedulingRedux from "./scheduling.redux"
import { searchFilterReducer } from "./search-filter/search-filter.reducer"
import { selectorReducer } from "./selector.redux"
import { vehicleReducer } from "./vehicle.redux"
import productionReducer, { ProductionState } from "./production.reducer"
// We do this in order to avoid the linter error
// when accessing the window.google.maps property
// in a .ts or .tsx file

export interface ApplicationState {
  scheduling: any
  vehicle: any
  selector: any
  allVehicles: AllVehiclesState
  demands: any
  dispatch: any
  production: ProductionState
  [key: string]: any
}
export const rootReducer = combineReducers<ApplicationState>({
  searchFilter: searchFilterReducer,
  scheduling: schedulingRedux,
  vehicle: vehicleReducer,
  selector: selectorReducer,
  allVehicles: allVehicleReducer,
  demands: demandReducer,
  orders: orderReducer,
  dispatch: dispatchReducer,
  reports: reportsReducer,
  production: productionReducer,
  auth: authReducer,
})

export default function configureStore() {
  if (process.env.NODE_ENV === "development") {
    return createStore(rootReducer, composeWithDevTools())
  } else {
    return createStore(rootReducer)
  }
}

// Export a custom hook so we don't have to inject ApplicationState type inference everytime
export function useTypedSelector(selector: (state: ApplicationState) => any) {
  return useSelector<ApplicationState>(selector)
}

// Mention all the modules as string over here to maintain consistency
export type Modules =
  | "scheduling"
  | "test"
  | "vehicles"
  | "allVehicles"
  | "demands"
  | "dashboard"
  | "benchmarks"
  | "orders"
  | "dms"
  | "dispatch"
  | "st_orderItems"
  | "st_orderTransactions"
  | "st_deliveryAgents"
  | "st_skuBookings"
  | "ecommerce"
  | "vendors"
  | "supplier"
  | "fund-flow"
  | "interfaces"
  | "sellable-items"
  | "distribution-centers"
  | "docks"
  | "production-batch-uploader"
  | "depot"
  | "allocation"
  | "sales-order"
  | "production"
